import { ToggleField } from 'components/molecules'
import InputField from 'components/molecules/input-field'
import LoaderButton from 'components/molecules/loader-button'
import GenericModal from 'components/organisms/generic-modal'
import { Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Button } from 'reactstrap'
import TimeUtil from 'utils/time-util'
import * as Yup from 'yup'


const propTypes = {
  modalProps: PropTypes.shape({
    isOpen : PropTypes.bool,
    toggle : PropTypes.func
  }).isRequired,
  onScheduleUpdatePrice: PropTypes.func.isRequired
}

const now = new Date()

const schema = Yup.object().shape({
  startsAt: Yup.date()
    .when('isInstant',(isInstant) => {
      if (!isInstant) {
        return Yup.date()
          .min(now,'Start Date should be in the future')
      }
    }),
  expiresAt: Yup.date()
    .when([ 'isInstant', 'startsAt', 'isManualExpire' ], (isInstant, startsAt, isManualExpire) => {
      if (isInstant && !isManualExpire) {
        return Yup.date()
          .min(now, 'End Date should be in the future')
          .typeError('End Date is required')
      }
      else {
        return Yup.date()
          .min(startsAt, 'End Date must be after Start Date')
          .typeError('End Date is required')
      }
    })
})
/**
 * Confirm modal-based form for inputing borrow quantity in Internal Request
 * @param {object} modalProps - Modal wrapper props
 * @param {func} onAddBorrowedInventory - Handler to add borrowed Inventory
 * @param {object} selectedCurrentInventory - Selected current Inventory
 */
const ScheduleMarketingDiscountModalForm = ({
  modalProps,
  onScheduleUpdatePrice
}) => (
  <GenericModal
    { ...modalProps }
    title={ 'Schedule Marketing Discount' }
  >
    <Formik
      initialValues={{
        isInstant      : false,
        startsAt       : TimeUtil.format(now, 'YYYY-MM-DDTHH:mm'),
        isManualExpire : false,
        expiresAt      : TimeUtil.format(now,'YYYY-MM-DDTHH:mm')
      }}
      validationSchema={ schema }
      onSubmit={ onScheduleUpdatePrice }
    >
      {
        (formikBag) => (
          <>
            <Form>
              <ToggleField
                type={ 'checkbox' }
                name={ 'isInstant' }
                label={ 'Instant Start' }
                formText={ 'Turning this on will trigger discount instantly' }
              />
              <InputField
                label='Starts At'
                type='datetime-local'
                name='startsAt'
                disabled={ formikBag.values.isInstant }
              />
              <ToggleField
                type={ 'checkbox' }
                name={ 'isManualExpire' }
                label={ 'Remove Discount Manually' }
                formText={ 'Turning this on will remove auto remove discount' }
              />

              <InputField
                label='Expires At'
                type='datetime-local'
                name='expiresAt'
                disabled={ formikBag.values.isManualExpire }
              />

              <div className='d-flex justify-content-center my-3'>
                <LoaderButton
                  color='primary'
                  type='submit'
                  onSubmit={ formikBag.submitForm }
                  disabled={ formikBag.isSubmitting }
                  isLoading={ formikBag.isSubmitting }
                  text='Submit'
                />
                <Button
                  color='danger'
                  onClick={ modalProps.toggle }
                >
                    Cancel
                </Button>
              </div>

            </Form>
          </>
        )
      }
    </Formik>
  </GenericModal>
)

ScheduleMarketingDiscountModalForm.propTypes = propTypes

export default ScheduleMarketingDiscountModalForm
